var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Definition from './definition';
import { mapValues, reduce, pick, flow } from 'lodash';
var DefinitionParser = /** @class */ (function () {
    function DefinitionParser() {
    }
    DefinitionParser.prototype.parse = function (raw) {
        var definition = (typeof raw === 'string' ? JSON.parse(raw) : raw);
        return new Definition(definition.id, definition.default_locale, this.mapActions(definition), this.mapRoutes(definition));
    };
    DefinitionParser.prototype.mapActions = function (definition) {
        var presentations = definition.actions ? definition.actions.presentations : {};
        var definitions = definition.actions ? definition.actions.definitions : {};
        return flow(function (data) {
            return mapValues(data, function (value, key) {
                var definition = definitions[value.action_id];
                return __assign({ id: key, action: __assign({}, pick(definition, ['domain', 'params']), { eventType: definition.event_type }) }, value);
            });
        }, function (data) {
            return reduce(data, function (result, value, key) {
                result.set(key, value);
                return result;
            }, new Map());
        })(presentations);
    };
    DefinitionParser.prototype.mapRoutes = function (definition) {
        var routes = definition.routes ? definition.routes : {};
        return flow(function (data) {
            return mapValues(data, function (value, key) {
                return {
                    id: value.route_id,
                    path: key,
                    actions: {
                        primary: (value.actions && value.actions.primary) || [],
                        secondary: (value.actions && value.actions.secondary) || [],
                    },
                };
            });
        }, function (data) {
            return reduce(data, function (result, value, key) {
                result.set(key, value);
                return result;
            }, new Map());
        })(routes);
    };
    return DefinitionParser;
}());
export default DefinitionParser;
//# sourceMappingURL=parse.js.map